import { Button, DataSource, Label, Layout, Switch, Table } from "@mcleod/components";

export abstract class AutogenLayoutUserList extends Layout {
    buttonLock: Button;
    buttonRevoke: Button;
    buttonRevokeAll: Button;
    buttonUnlock: Button;
    labelPageTitle: Label;
    sourceUsers: DataSource;
    switchActive: Switch;
    tableSearch: Table;
}
